import React, { useEffect, useState } from "react";
import Preloader from "../../Shared/Preloader/Preloader";
import Sidebar from "../../Shared/Sidebar";
import LessSidebar from "../../Shared/LessSidebar";
import Navbar from "../../Shared/Navbar/Navbar";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  InputGroup,
  Modal,
  ModalFooter,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faEnvelope,
  faHouseUser,
  faInfoCircle,
  faPhoneAlt,
  faPlus,
  faPlusCircle,
  faSave,
  faShare,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { useNavigate } from "react-router-dom";
import { currentUser } from "../../../authentication/auth";
import { axiosInstance } from "../../../config/axios";
import { APIURL, getPages } from "../../../configApi";
import DentistsTable from "../../Shared/components/Table/DentistsTable";
import RegisterService from "../../services/RegisterService";
import axios from "axios";
import PaginatorDentistList from "../../Shared/components/Paginator/PaginatorDentistList";
import FirebaseNotif from "../../Shared/FirebaseNotif/FirebaseNotif";
import DentistsTableForAgent from "../../Shared/components/Table/DentistsTableForAgent";

const AgentDentistList = () => {
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    state_id: "",
    city_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const [email, setEmail] = useState(null);
  const [addedType, setAddedType] = useState(0);
  const [showDefault, setShowDefault] = useState(false);
  const handleClose = () => {
    setShowDefault(false);
    setAddedType(0);
  };

  const [dentists, setDentists] = useState([]);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [pages, setPages] = useState(0);

  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [description, setDescription] = useState("");
  const [country_id, setCountryId] = useState(1);
  const [state_id, setStateId] = useState(0);
  const [city_id, setCityId] = useState(0);
  const [principal_phone, setPrincipalPhone] = useState("");
  const [ordinal_number_dentist, setOrdinalNumberDentist] = useState(1);
  const [full_address, setFullAdress] = useState();

  const getCountries = async () => {
    try {
      const response = await RegisterService.getCountries();
      setCountries(response.data.data);
      // console.log("countries", response.data.data);
    } catch (err) {
      // console.log(err);
    }
  };
  const getStates = async (idCountry) => {
    try {
      const response = await RegisterService.getStates(idCountry);
      setStates(response.data.data);
      // console.log("states", response.data.data);
    } catch (err) {
      // console.log(err);
    }
  };
  const getCities = async (idState) => {
    try {
      const response = await RegisterService.getCities(idState);
      setCities(response.data.data);
      // console.log("cities", response.data.data);
    } catch (err) {
      // console.log(err);
    }
  };

  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
    }
    //getAgents()
    getDentists();
    getCountries();
    getStates(1);
  }, []);
  const getDentists = () => {
    axiosInstance
      .get(`${APIURL}/laboratory/dentists`)
      .then((res) => {
        setDentists(res.data.data.list);
        setPages(getPages(res.data.data.total));
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const sendNewInvitation = (e) => {
    e.preventDefault();
    axiosInstance
      .post(`${APIURL}/global/request_invitations`, { email: email })
      .then((res) => {
        NotificationManager.success(
          "Invitation envoye avec succès",
          "Notification"
        );
        setShowDefault(false);
        setEmail("");
      })
      .catch((err) => {
        NotificationManager.error(err.response.data.message, "Notification");
        setEmail("");
      });
  };

  const changeAddedType = (e) => {
    // console.log("type is changing");
    setAddedType(e);
  };

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setCityId(0);
    setStateId(0);
    setFullAdress("");
    setPrincipalPhone("");
    setDescription("");
    setOrdinalNumberDentist("");
  };
  const verifForm = () => {
    if (first_name.length == 0) {
      setErrors({
        first_name: "Nom est obligatoire",
      });
      setLoading(false);
      return false;
    }
    if (last_name.length == 0) {
      setErrors({
        last_name: "Prenom est obligatoire",
      });
      setLoading(false);
      return false;
    }
    if (state_id == 0) {
      setErrors({
        state_id: "Gouvernorat est obligatoire",
      });
      setLoading(false);
      return false;
    }
    if (city_id == 0) {
      setErrors({
        city_id: "Ville est obligatoire",
      });
      setLoading(false);
      return false;
    }

    if (principal_phone.length == 0) {
      setErrors({
        principal_phone: "Téléphone est obligatoire",
      });
      setLoading(false);
      return false;
    }

    return true;
  };

  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar
          user={user}
          pageName={"Liste des dentistes"}
          icon={faHouseUser}
        />
        <hr />
        <div>
          <NotificationContainer />

          <div>
            {dentists && dentists.length > 0 ? (
              <DentistsTableForAgent
                setUsers={(value) => setDentists(value)}
                pages={pages}
                name={"Liste des dentistes"}
                users={dentists}
                headColumns={["first_name", "principal_phone", "last_name"]}
                refreshUsers={() => getDentists()}
              />
            ) : (
              "No data found .."
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default AgentDentistList;
